var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.361,
    height: 20,
    viewBox: "0 0 17.361 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Timer",
    d: "M367-439.633a8.632,8.632,0,0,1,8.633-8.633,8.61,8.61,0,0,1,6.354,2.789L383-446.24l.015-.011h0a.48.48,0,0,1,.672.095l.288.383.277.367.011.015h0a.479.479,0,0,1-.095.671l0,0-.013.01-.75.565-.282.213a8.6,8.6,0,0,1,1.143,4.3A8.632,8.632,0,0,1,375.633-431,8.632,8.632,0,0,1,367-439.633Zm1.631,0a7.01,7.01,0,0,0,7,7,7.01,7.01,0,0,0,7-7,7.011,7.011,0,0,0-7-7A7.011,7.011,0,0,0,368.631-439.633Zm6.187,0v-4.8a.816.816,0,0,1,.815-.815.816.816,0,0,1,.815.815v4.8a.816.816,0,0,1-.815.815A.816.816,0,0,1,374.818-439.633Zm-2.062-9.736a.815.815,0,0,1-.815-.815.815.815,0,0,1,.815-.815h5.755a.815.815,0,0,1,.815.815.815.815,0,0,1-.815.815Z",
    transform: "translate(-367 451)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/Timer.f979e99895f78d45b68ce935d0edf18d.svg";
export { ForwardRef as ReactComponent };